<div class="filling-helper-bar" data-testid="filling-helper">
  <span class="filling-helper-title" translate>FILLING_HELPER_TITLE</span>

  <span class="filling-helper-count filled" data-testid="filling-helper-count" *ngIf="remaining === 0" translate>
    FILLING_HELPER_ALL_FILLED
  </span>
  <span class="filling-helper-count" data-testid="filling-helper-count" *ngIf="remaining > 0">
    {{ 'FILLING_HELPER_REMAINING' | translate:{ count: remaining } }}
  </span>

  <span class="filling-helper-actions">
    <button type="button" class="btn btn-default btn-sm filling-helper-btn"
            data-testid="filling-helper-previous"
            *ngIf="started" (click)="previous.emit()" translate>Previous</button>

    <button type="button" class="btn btn-primary btn-sm filling-helper-btn"
            data-testid="filling-helper-start"
            *ngIf="!started" (click)="start.emit()" translate>Start filling</button>

    <button type="button" class="btn btn-primary btn-sm filling-helper-btn"
            data-testid="filling-helper-next"
            *ngIf="started" (click)="next.emit()" translate>Next</button>
  </span>
</div>
